export default __webpack_public_path__ + "static/media/logo.fc1fff51.svg";